import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { guard } from '../auth';
import { ModType } from '../mod/mod.types';
import { HintListPage } from './hint-list.page';

export const HintPage: FC = () => {
  return (
    <Routes>
      <Route path="mod" element={guard(<HintListPage type={ModType.MOD} />)} />
      <Route path="map" element={guard(<HintListPage type={ModType.MAP} />)} />
      <Route path="seed" element={guard(<HintListPage type={ModType.SEED} />)} />
      <Route path="skin" element={guard(<HintListPage type={ModType.SKIN} />)} />
      <Route path="*" element={<Navigate to="/auth" />} />
    </Routes>
  );
};
